const env = process.env.REACT_APP_TEST ? process.env.REACT_APP_TEST : "local";

const BUSINESS_SERVICE_URL = {
    local: "http://localhost:8082",
    test: "http://172.24.49.63:8082",
    preprod: "https://test.yhglas.com/be",
    prod: "https://yhglas.com/BE",
};

const KEYCLOAK_CONFIGS = {
    local: {
        realm: "GLAS",
        url: "http://localhost:8080/auth/",
        clientId: "glas-client",
        "ssl-required": "external",
        "public-client": true,
    },
    test: {
        realm: "GLAS",
        url: "http://172.24.49.63:8080/auth/",
        clientId: "glas-client",
        "ssl-required": "external",
        "public-client": true,
    },
    preprod: {
        "realm": "yildiz",
        "url": "https://rh-sso-test.yildizholding.com.tr/auth/",
        "clientId": "Glas",
        "ssl-required": "external",
        "public-client": true,
    },
    prod: {
        "realm": "yildiz",
        "url": "https://rh-sso.yildizholding.com.tr/auth/",
        "clientId": "Glas",
        "ssl-required": "external",
        "public-client": true
    },
};

export const DEFAULT_SERVICE = BUSINESS_SERVICE_URL[env];

export const KEYCLOAK_CONFIG = KEYCLOAK_CONFIGS[env];